import React, { useState, useEffect } from 'react';
import moment from 'moment';

const CalculateHours = ({ inTime, outTime }) => {
  // 1. Create a state for the current time to trigger re-renders
  const [now, setNow] = useState(moment());

  useEffect(() => {
    // Only set up the interval if outTime is missing
    if (!outTime) {
      const interval = setInterval(() => {
        setNow(moment());
      }, 60000); // 60,000ms = 1 minute

      // Clean up the interval on component unmount
      return () => clearInterval(interval);
    }
  }, [outTime]);

  // 2. Determine end point: Provided outTime or the "now" state
  const start = moment(inTime, "YYYY-MM-DD HH:mm:ss");
  const end = outTime ? moment(outTime, "YYYY-MM-DD HH:mm:ss") : now;

  // Validation
  if (!start.isValid() || !end.isValid()) {
    return <span className="text-red-500">Invalid Date</span>;
  }

  // 3. Calculation
  const duration = moment.duration(end.diff(start));
  const hours = Math.floor(duration.asHours());
  const minutes = duration.minutes();

  // Handle edge case where start might be in the future
  if (duration.asMilliseconds() < 0) {
    return <span>0h 0m</span>;
  }

  return (
    <>
      <span className="font-mono">
        {hours}h {minutes}m
      </span>
    </>
  );
};

export default CalculateHours;